import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-playIcon",
  "use": "icon-playIcon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-playIcon\"><defs></defs><title>资源 7</title><g id=\"icon-playIcon_图层_2\" data-name=\"图层 2\"><g id=\"icon-playIcon_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M10,20A10,10,0,1,1,20,10,10,10,0,0,1,10,20ZM10,1.9A8.1,8.1,0,1,0,18.1,10,8.12,8.12,0,0,0,10,1.9Z\" /><polygon class=\"cls-1\" points=\"14.57 10.29 7.91 6.44 7.91 14.13 14.57 10.29\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/svg/playIcon.svg
// module id = L/z4
// module chunks = 41